document.querySelectorAll('[data-ledi-cart]').forEach((section) => {
  if (section.dataset.lediCartReady === 'true') return;
  section.dataset.lediCartReady = 'true';

  section.addEventListener('click', (event) => {
    const button = event.target.closest('[data-qty-button]');
    if (button) {
      const wrap = button.closest('[data-qty]');
      const input = wrap && wrap.querySelector('input[data-qty-input]');
      const form = button.closest('form');

      if (!input || !form) return;

      const direction = button.getAttribute('data-qty-button');
      const min = Number(input.getAttribute('min') || 0);
      const nextValue = Number(input.value || 0) + (direction === 'plus' ? 1 : -1);
      input.value = String(Math.max(min, nextValue));

      const submitter = form.querySelector('[data-cart-update]');
      if (submitter && typeof form.requestSubmit === 'function') {
        form.requestSubmit(submitter);
      } else {
        form.submit();
      }
    }

    const promoButton = event.target.closest('[data-discount-apply]');
    if (promoButton) {
      const form = promoButton.closest('[data-discount-form]');
      const input = form && form.querySelector('input[name="discount"]');
      const code = input && input.value ? input.value.trim() : '';

      if (!code) return;

      window.location.href = '/discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent('/cart');
    }
  });

  section.addEventListener('change', (event) => {
    const input = event.target.closest('input[data-qty-input]');
    if (!input) return;

    const form = input.closest('form');
    const submitter = form && form.querySelector('[data-cart-update]');

    if (!form) return;

    if (submitter && typeof form.requestSubmit === 'function') {
      form.requestSubmit(submitter);
    } else {
      form.submit();
    }
  });
});
